var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-mask',[_c('div',{staticClass:"rank-panel",style:(_vm.panelStyle)},[_c('el-carousel',{attrs:{"type":"card","autoplay":false,"initial-index":_vm.index,"height":_vm.config.height * 0.9 + 'px'}},_vm._l((_vm.rankCarousel),function(item,index){return _c('el-carousel-item',{key:index},[_c('carousel-item',{attrs:{"data":item}})],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }